'use client';

import type { GetAllCollectionsOutputDTO } from '@algoacademy/backend/modules/docs/endpoints/queries/get-all-collections/output.dto';
import { Button } from '@algoacademy/design-system/web/actions/Button';
import { P2 } from '@algoacademy/design-system/web/typography/Paragraph';
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/16/solid';
import { useRef, useState } from 'react';
import { cn } from '@/app/_lib/utils';
import { CollectionCard } from './CollectionCard';
export type CollectionsGridProps = {
  collections?: GetAllCollectionsOutputDTO['allCollections'];
  className?: string;
};
export function CollectionsGrid({
  collections,
  className = ''
}: CollectionsGridProps) {
  const manyCollections = collections?.length && collections.length > 6;
  const [showAll, setShowAll] = useState<boolean>(false);
  const contentRef = useRef<HTMLDivElement>(null);
  const firstNine = collections?.slice(0, 9);
  const rest = collections?.slice(9);
  if (!collections || collections.length === 0) {
    return <P2 className='px-4 text-contentTertiary italic'>Brak kolekcji</P2>;
  }
  return <main className='flex flex-col items-center gap-3'>
      <div className={cn(collections.length === 1 ? 'grid grid-cols-1' : 'grid max-w-4xl grid-cols-1 items-start justify-items-center gap-6 lg:grid-cols-2', manyCollections && 'max-w-full lg:grid-cols-3', className)}>
        {firstNine?.map((collection: GetAllCollectionsOutputDTO['allCollections'][number]) => {
        return <CollectionCard key={collection.id} collection={collection} />;
      })}
      </div>

      <div ref={contentRef} style={{
      maxHeight: showAll ? contentRef.current?.scrollHeight : 0
    }} className='w-full overflow-hidden transition-[max-height] duration-500 ease-in-out'>
        <div className={cn('mt-3 grid max-w-4xl grid-cols-1 justify-items-center gap-6 lg:grid-cols-2', manyCollections && 'max-w-full lg:grid-cols-3')}>
          {rest?.map(collection_0 => {
          return <CollectionCard key={collection_0.id} collection={collection_0} />;
        })}
        </div>
      </div>

      {collections && collections.length > 9 && <Button plain onClick={() => setShowAll(!showAll)}>
          {showAll ? <>
              Pokaż mniej kolekcji <ChevronUpIcon />
            </> : <>
              Pokaż więcej kolekcji <ChevronDownIcon />
            </>}
        </Button>}
    </main>;
}